import { schema } from 'normalizr';

export const dashboard = new schema.Entity('dashboard');

dashboard.define({
  portfolios: require('shared/store/modules/portfolios/schemas').portfolios
});
